// assets
import { DashboardOutlined, BarChartOutlined, LineChartOutlined, TeamOutlined, CameraOutlined } from '@ant-design/icons';
import { ROLES } from '../lib/auth/roles';

// icons
const icons = {
  DashboardOutlined,
  BarChartOutlined,
  LineChartOutlined,
  TeamOutlined,
  CameraOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const reports = {
  id: 'group-reports',
  title: 'Reports',
  type: 'group',
  // leave group public; only children are gated
  children: [
    {
      id: 'reports-me',
      title: 'My Results',
      type: 'item',
      url: '/reports/me',
      icon: icons.BarChartOutlined,
      breadcrumbs: false,
      // Hosts & up (incl. Ambassadors, DJs if you want)
      allowedRoles: [
        ROLES.DJ,
        ROLES.AMBASSADOR,
        ROLES.HOST,
        ROLES.HEAD_HOST,
        ROLES.MANAGEMENT,
        ROLES.ADMIN
      ]
    },
    {
      id: 'reports-team',
      title: 'Team Results',
      type: 'item',
      url: '/reports/team',
      icon: icons.LineChartOutlined,
      breadcrumbs: false,
      // Head Host & up
      allowedRoles: [ROLES.HEAD_HOST, ROLES.AMBASSADOR, ROLES.MANAGEMENT, ROLES.ADMIN]
    },
    {
      id: 'reports-team-birthday',
      title: 'Team Birthdays',
      type: 'item',
      url: '/reports/team-birthday',
      icon: icons.LineChartOutlined,
      breadcrumbs: false,
      // Head Host & up
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'reports-all',
      title: 'All Reports',
      type: 'item',
      url: '/reports',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      // Management & Admin
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'reports-host-photo-attendance',
      title: 'Host Attendance',
      type: 'item',
      url: '/reports/host-photo-attendance',
      icon: icons.CameraOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'reports-current-team',
      title: 'Current Team',
      type: 'item',
      url: '/reports/current-team',
      icon: icons.TeamOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.HEAD_HOST, ROLES.AMBASSADOR, ROLES.MANAGEMENT, ROLES.ADMIN]
    }
  ]
};

export default reports;
